import React from 'react';
import { Home, Waves, Droplets, Sun, Building2, Truck, Trash2, Zap } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './Card';
const RESIDENTIAL_SERVICES = [{
  title: 'House Soft Washing',
  description: 'Safe, low-pressure cleaning that removes algae and dirt without damaging your siding or stucco.',
  icon: Home
}, {
  title: 'Driveway & Concrete',
  description: 'High-pressure surface cleaning to blast away oil stains, tire marks, and grime from your concrete.',
  icon: Waves
}, {
  title: 'Roof Cleaning',
  description: 'Gentle soft washing to remove black streaks and moss, extending the life of your roof.',
  icon: Droplets
}, {
  title: 'Pool Deck & Patio',
  description: 'Restore your outdoor living spaces to their original glory, safe for pavers and cool deck.',
  icon: Sun
}];
const COMMERCIAL_SERVICES = [{
  title: 'Storefront & Building',
  description: 'Make a great first impression with a spotless exterior for your retail or office building.',
  icon: Building2
}, {
  title: 'Dumpster Pad Cleaning',
  description: 'Eliminate odors and grease buildup with hot water pressure washing and sanitization.',
  icon: Trash2
}, {
  title: 'Fleet & Equipment',
  description: 'Keep your company vehicles and heavy machinery looking professional and well-maintained.',
  icon: Truck
}];
export function Services() {
  return <section id="services" className="py-24 bg-dark relative overflow-hidden" data-id="element-224">
      <div className="absolute top-0 right-0 opacity-5 pointer-events-none transform translate-x-1/3 -translate-y-1/3" data-id="element-225">
        <svg width="600" height="600" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" data-id="element-226">
          <path fill="#dc2626" d="M45.7,-76.4C58.9,-69.3,69.1,-55.3,77.5,-40.5C85.9,-25.7,92.5,-10.1,90.4,4.6C88.3,19.3,77.5,33.1,65.8,44.3C54.1,55.5,41.5,64.1,27.3,70.5C13.1,76.9,-2.7,81.1,-18.2,78.9C-33.7,76.7,-48.9,68.1,-60.8,56.1C-72.7,44.1,-81.3,28.7,-84.5,12.3C-87.7,-4.1,-85.5,-21.5,-77.3,-36.1C-69.1,-50.7,-54.9,-62.5,-40.1,-68.9C-25.3,-75.3,-9.9,-76.3,6.3,-84.1C22.5,-91.9,32.5,-83.5,45.7,-76.4Z" transform="translate(100 100)" data-id="element-227" />
        </svg>
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-228">
        <div className="text-center mb-16" data-id="element-229">
          <h2 className="font-display text-4xl md:text-5xl text-white uppercase tracking-wide mb-4" data-id="element-230">
            Precision Cleaning for{' '}
            <span className="text-accent" data-id="element-231">Every Surface</span>
          </h2>
          <p className="text-slate-400 max-w-2xl mx-auto text-lg" data-id="element-232">
            From delicate stucco to tough concrete, we have the right pressure
            and solutions for the job.
          </p>
        </div>

        <div className="mb-16" data-id="element-233">
          <h3 className="text-2xl font-bold text-white mb-8 flex items-center gap-3 border-b border-accent/20 pb-4" data-id="element-234">
            <Home className="h-6 w-6 text-accent" data-id="element-235" />
            Residential Services
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-236">
            {RESIDENTIAL_SERVICES.map((service, idx) => <ServiceCard key={idx} {...service} data-id="element-237" />)}
          </div>
        </div>

        <div data-id="element-238">
          <h3 className="text-2xl font-bold text-white mb-8 flex items-center gap-3 border-b border-accent/20 pb-4" data-id="element-239">
            <Building2 className="h-6 w-6 text-accent" data-id="element-240" />
            Commercial Services
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-241">
            {COMMERCIAL_SERVICES.map((service, idx) => <ServiceCard key={idx} {...service} data-id="element-242" />)}
          </div>
        </div>
      </div>
    </section>;
}
function ServiceCard({
  title,
  description,
  icon: Icon
}: {
  title: string;
  description: string;
  icon: any;
}) {
  return <Card className="bg-surface border-accent/20 hover:border-accent/60 transition-all duration-300 group hover:shadow-[0_0_30px_rgba(220,38,38,0.15)] relative overflow-hidden" data-id="element-243">
      <div className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-244">
        <Zap className="h-5 w-5 text-accent/50" data-id="element-245" />
      </div>
      <CardHeader data-id="element-246">
        <div className="h-12 w-12 rounded-lg bg-dark border border-accent/30 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300" data-id="element-247">
          <Icon className="h-6 w-6 text-accent" data-id="element-248" />
        </div>
        <CardTitle className="text-xl text-white" data-id="element-249">{title}</CardTitle>
      </CardHeader>
      <CardContent data-id="element-250">
        <CardDescription className="text-slate-400 text-base mb-6" data-id="element-251">
          {description}
        </CardDescription>
        <a href="#contact" className="text-accent font-bold uppercase tracking-wider text-sm hover:text-accent-light transition-colors inline-flex items-center gap-2" data-id="element-252">
          Get Quote
          <span className="group-hover:translate-x-1 transition-transform" data-id="element-253">
            →
          </span>
        </a>
      </CardContent>
    </Card>;
}